// export const API = {
//     // BASE_URL: 'https://opsapis.xpansecoffee.com',
//     BASE_URL: 'https://xpanse.dev.bexcart.com/',

// }


import axios from "axios";

const axiosInstance = axios.create({
    
    // Development URL
    // baseURL: "https://xpanse.dev.bexcart.com/",

    // Production URL
    baseURL: "https://admin.api.xpansecafe.com/",

    headers: {
        "Content-Type": "application/json",
    },
});

// Attach the staff auth token (if present) to every outgoing request.
axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    console.log("Token Outside If :", token);
    
    if (token) {
        console.log("Token Inside If :", token);
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default axiosInstance;